import { h } from "@stencil/core";
import { renderShowcaseProperties } from "../utils";
const state = {};
const render = () => (h("div", { class: "checkbox-test-main-wrapper" }, h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "No label"), h("ch-slider", { accessibleName: state.accessibleName, class: "slider slider-primary", disabled: state.disabled, maxValue: state.maxValue, minValue: state.minValue, showValue: state.showValue, step: state.step, value: state.value })), h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "Label with HTML for"), h("label", { class: "label", htmlFor: "slider-2" }, "Label for slider 2"), h("ch-slider", { id: "slider-2", accessibleName: state.accessibleName, class: "slider slider-primary", disabled: state.disabled, maxValue: state.maxValue, minValue: state.minValue, showValue: state.showValue, step: state.step, value: state.value })), h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "Component inside label"), h("label", { class: "label", htmlFor: "slider-3" }, "Label for slider 3", h("ch-slider", { id: "slider-3", accessibleName: state.accessibleName, class: "slider slider-primary", disabled: state.disabled, maxValue: state.maxValue, minValue: state.minValue, showValue: state.showValue, step: state.step, value: state.value })))));
const showcaseRenderProperties = [
    {
        caption: "Models",
        properties: [
            {
                id: "value",
                caption: "Value",
                value: 2,
                type: "number"
            },
            {
                id: "maxValue",
                caption: "Max Value",
                value: 5,
                type: "number"
            },
            {
                id: "minValue",
                caption: "Min Value",
                value: 0,
                type: "number"
            },
            {
                id: "step",
                caption: "Step",
                value: 0.1,
                type: "number"
            }
        ]
    },
    {
        caption: "Properties",
        properties: [
            {
                id: "accessibleName",
                caption: "Accessible Name",
                value: "Option",
                type: "string"
            },
            {
                id: "disabled",
                caption: "Disabled",
                value: false,
                type: "boolean"
            },
            {
                id: "showValue",
                caption: "Show Value (not supported yet)",
                value: false,
                type: "boolean"
            }
        ]
    }
];
const showcasePropertiesInfo = [
    { name: "accessibleName", defaultValue: undefined, type: "string" },
    {
        name: "class",
        fixed: true,
        value: "slider",
        type: "string"
    },
    { name: "disabled", defaultValue: false, type: "boolean" },
    { name: "maxValue", defaultValue: 5, type: "number" },
    { name: "minValue", defaultValue: 0, type: "number" },
    { name: "step", defaultValue: 1, type: "number" },
    { name: "value", defaultValue: 0, type: "number" },
    { name: "input", fixed: true, value: "handleInput", type: "event" }
];
export const sliderShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithoutUIModel: {
        react: () => `<ChSlider${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
      ></ChSlider>`,
        stencil: () => `<ch-slider${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
        ></ch-slider>`
    },
    render: render,
    state: state
};
